import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'local-seo-connected-account-modal',
  templateUrl: './connected-account-modal.component.html',
  styleUrls: ['./connected-account-modal.component.scss'],
  standalone: false,
})
export class ConnectedAccountModalComponent {
  sourceId: string;
  accountName: string;
  accountLink: string;
  sourceName: Record<number, string> = {
    10010: 'Google',
    10050: 'Facebook',
    10060: 'Twitter',
  };

  readonly GOOGLE_MY_BUSINESS = 'Google My Business';
  readonly FACEBOOK = 'Facebook';
  readonly TWITTER = 'Twitter';

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      sourceId: string;
      accountName: string;
      accountLink: string;
    },
  ) {
    this.sourceId = data?.sourceId;
    this.accountName = data?.accountName;
    this.accountLink = data?.accountLink;
  }
}
